import { render } from "./ModalDetalleError.vue?vue&type=template&id=8bd85142"
import script from "./ModalDetalleError.vue?vue&type=script&lang=js"
export * from "./ModalDetalleError.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__